import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

// Global cache — evita múltiplos requests
let _cachedLogo = null;
const _subs = new Set();

export function useLogo() {
  const [config, setConfig] = useState(_cachedLogo);

  useEffect(() => {
    _subs.add(setConfig);
    if (!_cachedLogo) {
      api.get("/config").then(({ data }) => {
        _cachedLogo = data;
        _subs.forEach((s) => s(data));
      }).catch(() => {
        _cachedLogo = { logo_path: null, nome_shopping: "VM Shopping" };
        _subs.forEach((s) => s(_cachedLogo));
      });
    }
    return () => _subs.delete(setConfig);
  }, []);

  return {
    logoUrl: config?.logo_path ? `${API}/config/logo/view?ts=${Date.now()}` : null,
    nome: config?.nome_shopping || "VM Shopping",
    invalidate: () => { _cachedLogo = null; },
  };
}

export function LogoOrText({ className = "", textClass = "" }) {
  const { logoUrl, nome } = useLogo();
  if (logoUrl) {
    return <img src={logoUrl} alt={nome} className={className} onError={(e) => { e.target.style.display = "none"; }} />;
  }
  return <span className={textClass}>{nome.toUpperCase()}</span>;
}
